import { Body, Box, Icon } from "@biom3/react";
import type React from "react";
import { Avatar } from "./Avatar";

interface HeaderProfilePillProps {
  gems: number;
  avatarUrl?: string;
  onClick?: () => void;
}

export const HeaderProfilePill: React.FC<HeaderProfilePillProps> = ({
  gems,
  avatarUrl,
  onClick,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: "999px",
        background: "transparent",
        border: "2px solid #fff",
        padding: "2px 2px 2px 8px",
        paddingLeft: {
          default: "2px",
          medium: "8px",
        },
        gap: "6px",
        boxSizing: "border-box",
        cursor: onClick ? "pointer" : "default",
        minHeight: "40px",
      }}
      onClick={onClick}
      data-testid="header-profile-pill"
    >
      <Box
        sx={{
          display: { default: "none", medium: "flex" },
          alignItems: "center",
        }}
      >
        <Icon
          icon="ImxRewards"
          variant="bold"
          sx={{ w: "20px", h: "20px", color: "#fff" }}
        />
        <Body
          size="medium"
          weight="bold"
          sx={{ fontSize: "18px", color: "#fff", letterSpacing: "0.01em" }}
        >
          {gems}
        </Body>
      </Box>
      <Avatar size={36} imageUrl={avatarUrl} noRing />
    </Box>
  );
};
